import { render, staticRenderFns } from "./Closes.vue?vue&type=template&id=b79f4a60&"
import script from "./Closes.vue?vue&type=script&lang=js&"
export * from "./Closes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Closes.vue"
export default component.exports